import { Box, Card, Grid, Typography, useTheme } from '@mui/material'
import ButtonBasic from '../buttons/ButtonBasic'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { showModal } from 'react-redux-modal-provider';
import ModalDashTickets from '../../modals/dashboard/ModalDashTickets';

const CardDashboardTotal = ({texto,cantidad,icon,items,isDarkMode}) => {
    const theme = useTheme();
    const darkModeActive = isDarkMode !== undefined ? isDarkMode : theme.palette.mode === 'dark';

    const onOpenModal = () =>{
        showModal(ModalDashTickets,{texto:texto, items:items})
    }

    return (
        <Card sx={{
            background: darkModeActive ? '#1F2A40 !important' : '#fff !important', 
            width: 280,
            borderRadius:5,
            boxShadow: darkModeActive ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)'
        }} className='cardDashboardTotal'>
            <Grid container mt={2} mb={1}>
                <Grid item xs={4} display='flex' justifyContent='center' mt={1}>
                    <Card sx={{
                        height: 50, 
                        width:50,
                        background: darkModeActive ? '#2d3a52 !important' : '#e6f0ff !important',
                        display: 'flex', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        '& svg': { color: darkModeActive ? '#64B5F6' : '#0364ff' }
                    }}>
                        {icon}
                    </Card>
                </Grid>
                <Grid item xs={8}>
                    <Typography sx={{color: darkModeActive ? '#e0e0e0' : '#000'}} variant='h4'>{texto}</Typography>
                    <Box display='flex' mt={1}>
                        <Typography sx={{color: darkModeActive ? '#fff' : '#000',fontWeight: 'bold'}} variant='h1'>{cantidad}</Typography>
                        <Typography sx={{color: darkModeActive ? '#b0b0b0' : '#000',marginTop: 3,marginLeft: 1}} variant='h5'>Total</Typography>
                    </Box>
                </Grid>
            </Grid>
            <Box p={1} mb={2}>
                <ButtonBasic
                    textButton='Más info'
                    className='buttonCardDashboardTotal'
                    fullWidth
                    disableElevation
                    sx={{
                        borderRadius: 20, 
                        background: darkModeActive ? '#2d3a52' : '#fff',
                        color: darkModeActive ? '#64B5F6' : '#0364ff',
                        fontWeight: 'bold', 
                        fontSize: 14,
                        '&:hover':{
                            background: darkModeActive ? '#3d4a62' : '#e6f0ff'
                        }
                    }}
                    iconEnd={<ArrowForwardIcon sx={{display: 'none'}} className='iconCardDashboardTotal' />}
                    onClick={()=>onOpenModal()}
                />
            </Box>
        </Card>
    )
}

export default CardDashboardTotal;